import { z } from 'zod'
import { NextPageContext } from 'next'

export const getNonceFromRequest = (req: NextPageContext['req']): string | undefined => {
  return z.string().safeParse(req?.headers['x-csp-nonce']).data
}
